var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"player",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }